{
    "image_upload_error": "Falha ao carregar a imagem. Tente recarregar esta página e selecione uma imagem novamente.",
    "search_placeholder": "Pesquisar fotos e ilustrações",
    "search": "Localizar",
    "photo": "Imagem",
    "image_by": "Por",
    "free_photos_from": "Imagens de estoque gratuitas de",
    "uploading": "Carregando...",
    "cancel": "Cancelar",
    "select": "Selecionar"
}
